export const enum LocalStorageKeysEnum {
  TOKEN = 'token',
  ID = 'id',
  PUBLISH_URL = 'PUBLISH_URL',
  ID_SERVEY = 'ID_SERVEY',
  TELEGRAM_BOT_LINK = 'TELEGRAM_BOT_LINK',
}

export const enum ApiUrlEnum {
  USER_AUTH = '/user/auth',
  USER_INFO = '/user/users/', // URL: /user/users/:id
  USER_LOGOUT = '/user/logout',
  USER_INIT = '/user/init',
  CONSTRUCTOR_SURVEYS = '/constructor/surveys',
  DUPLICATE = '/duplicate',
  ALL_SURVEY = '/constructor/surveys',
  CREATE_SURVEYS = '/constructor/surveys',
  ADD_IMAGES = '/fs/images-upload',
  DELETE_IMAGES = '/fs/images',
  DELETE_SURVEY = '/constructor/surveys',
  PUBLISH_SURVEY = '/constructor/surveys',
  ALL_TAG = '/constructor/tags',
  IMPORT_SURVEY = '/constructor/surveys-import',
  TAKING_SURVEY = '/walkthrough/s/',
  ANALYTIC = '/analytic/g/',
  USER_USERS = '/user/users',
  COMPLETED_SURVEYS = '/completed-surveys',
  IMPORT_EXAMPLE = '/constructor/surveys-import-example',
}

export const enum ErrorUrlEnum {
  ERROR = '/error',
  ERROR_403 = '/error/403',
  ERROR_404 = '/error/404',
  ERROR_503 = '/error/503',
  ERROR_500 = '/error/500',
}

export enum TabsTestParameter {
  Setting = 'settings',
  Content = 'сontent',
}

export enum ChangeQuestionAnswerEnum {
  Text = 'text',
  Select = 'select',
}

export const enum SurveyTypeEnum {
  SURVEY,
  TEST,
}

export const enum SurveyStatusEnum {
  DRAFT,
  PUBLISHED,
  ENDED,
}

export const enum QuestionTypeEnum {
  SINGLE_SELECT,
  MULTIPLE_SELECT,
  SELF_SELECT,
  SINGLE_AND_SELF,
  MULTIPLE_AND_SELF,
  POINT_RATING,
  MULTIPLE_POINT_RATING,
}

export const enum AnalyticTabsEnum {
  ALL_RESULT,
  TABLE,
}

export const enum AnalyticResultItemEnum {
  NUMBER,
  DATE,
  POINTS,
}

export const enum TitleTestEnum {
  New = 'new',
  Edit = 'edit',
}

export const enum StatusInformerEnum {
  Success = 'success',
  System = 'system',
  Alert = 'alert',
  Warning = 'warning',
}

export enum InformerStatusTitleEnum {
  DELETE_SUCCESS = 'Успешно удалён',
  END_SUCCESS = 'Опрос завершён ',
  PUBLISH_SUCCESS = 'Опрос опубликован',
  DUPLICATE_SUCCESS = 'Успешно дублирован',
  IMPORT_SURVEY_SUCCESS = 'Теперь вы можете перейти к списку вопросов',
  IMPORT_SURVEY_WARNING = 'Попробуйте загрузить другой файл',
  PUBLISH_WARNING = 'Попробуйте еще раз',
  DELETE_WARNING = 'Попробуйте еще раз',
  STATUS_WARNING = 'Попробуйте еще раз',
}

export const enum SortValueEnum {
  INCREASE = 1,
  DECREASE = 2,
  NORMAL = 3,
}

export enum TakingSurveyEnum {
  SINGLE_SELF_CHOICE = 'singleSelfChoice',
}

export enum TestFormTypeCounterEnum {
  FULL_OVERLAP,
  PARTIAL_OVERLAP,
}

export enum VisiblePassword {
  Password = 'password',
  Text = 'text',
}
